import React, { ReactElement, useContext } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import ErrorMessage from '../common/ErrorMessage'
import { EntryContext, contextConfig } from '../contexts/EntryContext'
import InfiniteScroll, { infiniteScrollConfig, InfiniteScrollHeader } from '../common/InfiniteScroll'
import { InfiniteScrollParams } from '../common/InfiniteScroll.d'
import EntryMetricGraph from './EntryMetricGraph'

export const EntryThumbnailListWithField = (props: Partial<InfiniteScrollParams>): ReactElement => {
    const { state: entries } = useContext(EntryContext)
    const urlParams = useParams()
    const queryParams = Object.fromEntries(new URLSearchParams(useLocation().search))
    if (!urlParams.field) {
        return <ErrorMessage error={ { message: 'No field specified. This is an internal error.' } } />
    }
    const params = { ...urlParams, ...queryParams, ...props, field: urlParams.field }

    return (
        <div className="thumbnail-list entry-thumbnail-list">
            <InfiniteScrollHeader { ...params } personLinkText="Featuring" />
            { !params.value && <EntryMetricGraph field={ params.field } from={ params.from } until={ params.until } /> }
            <InfiniteScroll { ...infiniteScrollConfig(contextConfig, entries, params) } />
        </div>
    )
}
